import React from 'react';
import { useNavigate } from 'react-router-dom';
import './faq.css';
import GetLangConfig from '../../util/LangUtil';

export default function Faq() {

    const history = useNavigate();
    const langConfig = GetLangConfig('faq');
 

    return (
            <div className="faq-container">
                <h1 dangerouslySetInnerHTML={{ __html: langConfig.faq.header }}></h1>
                <p className="question">{langConfig.faq.faqp1}</p>
                <p>{langConfig.faq.faqp2}</p>
                <ul>
                    <li>{langConfig.faq.list1line1}</li>
                    <li>{langConfig.faq.list1line2}</li>
                </ul>

                <p className="question">{langConfig.faq.faqp3}</p>
                <p dangerouslySetInnerHTML={{ __html: langConfig.faq.faqp4 }}/>

                <p className="question">{langConfig.faq.faqp5}</p>
                <p dangerouslySetInnerHTML={{ __html: langConfig.faq.faqp6 }}></p>

                <p className="question">{langConfig.faq.faqp7}</p>
                <p>{langConfig.faq.faqp8}</p> 
                <ul>
                    <li>{langConfig.general.policyPlan}</li>
                    <li>{langConfig.general.certificateNumber}</li>
                    <li>{langConfig.general.orgDealerName}</li>
                    <li>{langConfig.general.planMemberName}</li>
                </ul>

                <p className="question">{langConfig.faq.faqp9}</p>
                <p>{langConfig.faq.faqp10}</p>

                <p className="question">{langConfig.faq.faqp11}</p>
                <p>{langConfig.faq.faqp12}</p> 

                <p className="question">{langConfig.faq.faqp13}</p>
                <p>{langConfig.faq.faqp14}</p>

                <p className="question">{langConfig.faq.faqp15}</p>
                <p>{langConfig.faq.faqp16}</p> 

                <p className="question">{langConfig.faq.faqp17}</p>
                <p>{langConfig.faq.faqp18}</p> 

                <p className="question">{langConfig.faq.faqp19}</p>
                <p>{langConfig.faq.faqp20}</p>

                <p className="question">{langConfig.faq.faqp21}</p>
                <p>{langConfig.faq.faqp22}</p>

                <p className="question">{langConfig.faq.faqp23}</p>
                <p>{langConfig.faq.faqp24}</p>

                <p className="question">{langConfig.faq.faqp25}</p>
                <p>{langConfig.faq.faqp26}</p>

                <p className="question">{langConfig.faq.faqp27}</p>
                <p>{langConfig.faq.faqp28}</p> 

                <p className="question">{langConfig.faq.faqp29}</p>
                <p>{langConfig.faq.faqp30}</p>

                <div className='contact-info-container'>
                    <h2>{langConfig.faq.header2}</h2>

                    <table>
                        <tbody>
                            <tr>
                                <td style={{ fontWeight: 'bold' }}>{langConfig.faq.tabletd1}</td>
                                <td dangerouslySetInnerHTML={{ __html: langConfig.faq.tabletd2 }}></td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 'bold' }}>{langConfig.faq.tabletd3}</td>
                                <td dangerouslySetInnerHTML={{ __html: langConfig.faq.tabletd4 }}></td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 'bold' }}>{langConfig.faq.tabletd5}</td>
                                <td dangerouslySetInnerHTML={{ __html: langConfig.faq.tabletd6 }}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

}
